import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { PaymentAccountBalanceReportResponse } from '@shared/api';
import { AmountUtils, DateUtils } from '@shared/utils';
import { Table, TableCellType } from '@shared/widgets';

interface DepositAccountTableProps {
  isLoading?: boolean;
  error?: string | null;
  onRefresh?: () => void;
  accounts: PaymentAccountBalanceReportResponse[];
  currentPage: number;
  totalItemCount: number;
  countItemPage: number;
  onChangePage: (pageNumber: number) => void;
  onChangeCountItemPage: (pageNumber: number) => void;
}
export const DepositAccountTable = (props: DepositAccountTableProps) => {
  const { t } = useTranslation('reports');

  const columns = useMemo(
    () => [
      t('payment.account.columns.date'),
      t('payment.account.columns.accountNumber'),
      t('payment.account.columns.accountName'),
      t('payment.account.columns.currency'),
      t('payment.account.columns.availableBalance'),
      t('payment.account.columns.blockedBalance'),
      t('payment.account.columns.totalBalance'),
    ],
    [t],
  );
  return (
    <Table
      isScrollable
      isLoading={props.isLoading}
      error={props.error}
      onRefresh={props.onRefresh}
      columns={columns}
      items={props.accounts.map((row) => [
        { type: TableCellType.Text, value: DateUtils.formatDate(row.dateCreated) },
        { type: TableCellType.Text, value: row.accountNumber.replaceAll('X', '*') },
        { type: TableCellType.Text, value: row.accountName || `*${row.accountNumber.slice(-4)}` },
        { type: TableCellType.Text, value: row.currency.toUpperCase() },
        { type: TableCellType.Text, value: AmountUtils.transformToAmountWithCurrency(row.availableBalance, row.currency) },
        { type: TableCellType.Text, value: AmountUtils.transformToAmountWithCurrency(row.blockedBalance, row.currency) },
        { type: TableCellType.Text, value: AmountUtils.transformToAmountWithCurrency(row.totalBalance, row.currency) },
      ])}
      pagination={{
        currentPage: props.currentPage,
        totalItemCount: props.totalItemCount,
        countItemPage: props.countItemPage,
        onChangePage: props.onChangePage,
        onChangeCountItemPage: props.onChangeCountItemPage,
      }}
    />
  );
};
